import styles from './index.module.sass'
import icon from './icon.svg'
import { Input } from 'antd'

export const Search = ({ value, onChange }: ISearch) => {
    return (
        <div className={styles.root}>
            <img src={icon} alt="search-icon"/>
            <Input className={styles.input} autoComplete="off" placeholder={'телефон, название компании ...'} value={value} onChange={onChange}/>
        </div>
    )
}

interface ISearch {
    value: string
    onChange: (e: any) => void
}